export const START_REQUEST = "START_DEVICES_REQUEST";
export const END_REQUEST = "END_DEVICES_REQUEST";
export const GET_DEVICES = "GET_DEVICES";
export const ADD_DEVICE = "ADD_DEVICE";
export const EDIT_DEVICE = "EDIT_DEVICE";